module.exports = __webpack_public_path__ + "img/logo-sxfgw.00085c5a.jpg";